/*
 * @Author: wangzhu
 * @Date: 2022-04-18 16:21:51
 * @LastEditTime: 2022-12-28 19:58:55
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 */
import axios from 'axios';
import { Toast } from 'vant';

console.log('process.env.VUE_APP_BASE_URL', process.env)
const config = {
  // baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'ShenDeng-bbs-backend-User': 'jingMe',
  },
};

const pcConfig = {
  // baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  timeout: 20000,
}
export const pcInstance = axios.create(pcConfig);

const withoutCookieConfig = {
  // baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: false,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
    'ShenDeng-bbs-backend-User': 'jingMe',
  },
}
export const withoutCookieInstance = axios.create(withoutCookieConfig);

const instance = axios.create(config);

// instance.defaults.headers.post['Content-Type'] = 'application/json';

instance.interceptors.request.use((reqConfig) => reqConfig, () => Promise.reject(new Error('error')));

const checkState = (res) => {
  if ((res.code !== 200 && res.status !== 201) && res.code !== 0) {
    const ua = (typeof window !== 'undefined' && window.navigator.userAgent) || ''
      const isInMobileJme = /JDME/i.test(ua) && /Mobile|Android|iPhone|iPad|iPod/i.test(ua)
    if (res.code === 401) {
      if (window.location.href.indexOf('programmer-day-2026') && !isInMobileJme) {
        window.location.href = 'http://ssa.jd.com/sso/login?ReturnUrl=' + encodeURIComponent(window.location.href)
      }
      return Promise.reject(res);
    }
    if (res.code === 403) {
      window.jme.browser.openUrl({
        url: `${process.env.VUE_APP_DOMAIN_URL}/withOutAuth?isHideShareButton=1`,
        closeBrowser: true
      });
      return Promise.reject(res);
    }
    Toast.fail(res.data || res.errMsg || res.message || '请求失败，请稍后重试')
    return Promise.reject(res);
  }
  return res;
};

const handleError = (error) => {
  const res = error.response?.data;
  if (res.code === 401) {
    window.location.href = process.env.VUE_APP_SSA_URL + encodeURIComponent(window.location.href);
    return Promise.reject(res);
  }
  Toast.fail(res.data || res.errMsg || res.message || '请求失败，请稍后重试')
  return Promise.reject(res);
};

instance.interceptors.response.use((response) => {
  const res = response.data;
  return checkState(res);
}, handleError);

pcInstance.interceptors.response.use((response) => {
  const res = response.data;
  return checkState(res);
}, handleError);

withoutCookieInstance.interceptors.response.use((response) => {
  const res = response.data;
  return checkState(res);
}, handleError);

export function request(requestObj) {
  if (requestObj.method === 'get') {
    Object.assign(requestObj, { params: requestObj.data });
  }
  // if (requestObj?.withoutCredentials)
  const localUid = localStorage.getItem('uid') || window.jmeUid
  if (localUid) {
    Object.assign(requestObj, { headers: {
      ...requestObj.headers,
      'ShenDeng-Bbs-Backend-JingMe-Uid': localUid
    } });
  }
  
  return instance(requestObj);
}

export default instance;
